import React from "react";

interface InputProps {
  label: string;
  name: string;
  type?: string;
  value: string;
  variant?: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  error?: string;
  inputMode?: React.HTMLAttributes<HTMLInputElement>["inputMode"];
  pattern?: string;
  maxLength?: number;
}

const InputField: React.FC<InputProps> = ({
  label,
  name,
  type = "text",
  value,
  onChange,
  variant,
  placeholder,
  error,
  inputMode,
  pattern,
  maxLength,
}) => {
  return (
    <div className="flex flex-col w-full">
      <label className="text-secondary-main font-medium mb-1">{label}</label>
      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        inputMode={inputMode}
        pattern={pattern}
        maxLength={maxLength}
        className={`border rounded-md p-4 py-2 w-full focus:border-[2px] outline-none ${
          variant
            ? "!border-[rgba(var(--primary-color-rgb),0.5)]"
            : "border-themeColor"
        } ${error ? "border-red-500" : ""}`}
      />
      {error && <span className="text-red-500 text-sm mt-1">{error}</span>}
    </div>
  );
};

export default InputField;
